export default {
  footer: {
    tagline: 'A World where People are Well-connected, Transparently and Fairly.',
    home: 'Home',
    aboutUs: 'About Us',
    philosophy: 'Philosophy',
    ourBusiness: 'Our Business',
    news: 'News',
    contacts: 'Contact',
    chemicalList: 'Chemical List',
    exportTerms: 'Export Terms',
    purchaseProcess: 'Purchase Process',
    companyProfile: 'Company Profile',
    history: 'History',
    missionStatement: 'Mission',
    coreValues: 'Values',
    tradingServices: 'Trading Services',
    importExportTerms: 'Import/Export Terms',
    chemicalTradeInfo: 'Chemical Trade Info',
    productList: 'Product List',
    latestNews: 'Latest Updates',
    contactForm: 'Contact Form',
    purchasingProcess: 'Purchasing Process',
    copyright: 'Copyright © 2026 Daishin Corporation. All Rights Reserved',
    sitePolicy: 'Site Policy',
    privacyPolicy: 'Privacy Policy',
    infoSecurityPolicy: 'Information Security Policy',
  },
};
